import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  AccountReceivableSearchCriteria,
  CustomerSearchCriteria,
  PageListBean,
  RestAccountReceivableListRequest,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { CustomerService } from "../services/CustomerService.js";
export class AccountReceivableLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new AccountReceivableSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new AccountReceivableSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let accountReceivableLookupCriteria = new AccountReceivableSearchCriteria();
    accountReceivableLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = AccountReceivableLookupCriteraHandler(
      companyCode,
      accountReceivableLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };

    this.setDetails(
      lookupDataCallback,
      accountReceivableLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getARStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Status", "accountReceivableStatus", 0, false); //2
    this.addColumnDefinition("Customer", "customerCode", 0, false); //3
    this.addColumnDefinition("Name", "customerName", 0, false); //4
    this.addColumnDefinition("ARDate", "accountReceivableDate", 0, false); //5
    this.addColumnDefinition("Currency", "customerCurrencyCode", 0, false);
    this.addColumnDefinition("CheckAmount", "checkAmount", 1, false);
    this.addColumnDefinition("CardAmount", "cardAmount", 1, false);
    this.addColumnDefinition("CashAmount", "cashAmount", 1, false);
    this.addColumnDefinition("WireAmount", "wireTransferAmount", 1, false);
    this.addColumnDefinition("ACHAmount", "autoClearingHouseAmount", 1, false);
    this.addColumnDefinition("Tot Recd Amt", "totalReceivedAmount", 1, false);
  }
  loadAccountReceivableList = (lookup_dialog, pageNumber, searchCriteria) => {
    let accountreceivable_criteria = new AccountReceivableSearchCriteria(); //To be fetched from CriteriaHandler
    accountreceivable_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      accountreceivable_criteria.accountReceivableNumber =
        searchCriteria.accountReceivableNumber;
      accountreceivable_criteria.customerCode = searchCriteria.customerCode;
      accountreceivable_criteria.accountReceivableNumberContains =
        searchCriteria.accountReceivableNumberContains;
      accountreceivable_criteria.accountReceivableNumberStartsWith =
        searchCriteria.accountReceivableNumberStartsWith;
      accountreceivable_criteria.accountReceivableStatus =
        searchCriteria.accountReceivableStatus;
      accountreceivable_criteria.createdDate = searchCriteria.createdDate;
      accountreceivable_criteria.checkNumber = searchCriteria.checkNumber;
      accountreceivable_criteria.wireTransferNumber =
        searchCriteria.wireTransferNumber;
      accountreceivable_criteria.cardNumber = searchCriteria.cardNumber;
      accountreceivable_criteria.achNumber = searchCriteria.achNumber;
      accountreceivable_criteria.totalReceivedAmount =
        searchCriteria.totalReceivedAmount;
    }

    let accountreceivable_pageList = new PageListBean();
    accountreceivable_pageList.pageSize = 50; //TODO --> Fetch from Config
    accountreceivable_pageList.currentPage = pageNumber;
    accountreceivable_pageList.pageNumber = pageNumber;
    let accountreceivable_requestInput = new RestAccountReceivableListRequest();
    accountreceivable_requestInput.pageInput = accountreceivable_pageList;
    accountreceivable_requestInput.searchCriteria = accountreceivable_criteria;
    AccountReceivableService.getAccountReceivablePageList(
      accountreceivable_requestInput,
      (response) =>
        this.loadAccountReceivableListResponse(response, lookup_dialog),
      this.loadAccountReceivableListError
    );
  };
  loadAccountReceivableListResponse = (response, lookup_dialog) => {
    let accountReceivableList = [];
    let finalARList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.accountReceivablePageList != null &&
      response.data.accountReceivablePageList.accountReceivables !== null
    ) {
      accountReceivableList =
        response.data.accountReceivablePageList.accountReceivables;
      totalCount = response.data.accountReceivablePageList.totalCount;
      currentPageNumber = response.data.accountReceivablePageList.currentPage;
      pageSize = response.data.accountReceivablePageList.pageSize;
      accountReceivableList.map((ar) => {
        ar.accountReceivableStatus = ModuleUtils.getARStatusCaption(
          ar.accountReceivableStatus
        );
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = accountReceivableList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };

  loadAccountReceivableListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.accountReceivableNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.accountReceivableNumberContains = filterText;
        this.searchCriteria = new AccountReceivableSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadAccountReceivableList(lookup_dialog, pageNumber, search);
    }
  }
}
const AccountReceivableLookupCriteraHandler = (companyCode) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new AccountReceivableSearchCriteria(),
        customerPageListForAutoCompleteList: new Array(),
        showAutoCompleteCustomerList: true,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let customerLookupHandler = new CustomerLookupHandler(
        companyCode,
        "Customer"
      );
      this.setState({ customerLookupHandler: customerLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new AccountReceivableSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    customerCodeOnChange = (e) => {
      let customerCode = e.target.value;
      this.state.showAutoCompleteCustomerList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      if (isEmpty(customerCode)) {
        this.state.showAutoCompleteCustomerList = false;
        let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteCustomerList: showAutoCompleteList,
          searchCriteria: criteria,
          customerPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "customerCode" &&
        showAutoCompleteList === true &&
        customerCode !== ""
      ) {
        this.readCustomerBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readCustomer = (customerCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = customerCode;
      input.isLoadChildren = true;
      CustomerService.readCustomer(
        input,
        this.editCustomerResponse,
        this.errorCallBack
      );
    };
    editCustomerResponse = (response) => {
      if (response.data.customer != null) {
        let customerData = response.data.customer;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = customerData.code;
        this.setState({ searchCriteria: criteria });
      }
    };
    readCustomerBySearchString(searchString) {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.customerCodeStartsWith = searchString;
      searchCriteria.customerNameContains = searchString;
      let cust_pageList = new RestPageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestCustomerListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    }
    readByCustomerCodeResponse = (response) => {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    customerCodeEnterKeyEventHandler = (e) => {
      let customerCode = e.target.value;
      this.readCustomer(customerCode);
      this.setState({
        customerPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
      });
    };
    errorCallBack = (error) => {
      ShowError(error);
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>accountReceivableNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="accountReceivableNumber"
                  name="accountReceivableNumber"
                  onChange={this.onChange}
                  value={searchCriteria.accountReceivableNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>accountReceivableNumberStartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="accountReceivableNumberStartsWith"
                  name="accountReceivableNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.accountReceivableNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>accountReceivableNumberContains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="accountReceivableNumberContains"
                  name="accountReceivableNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.accountReceivableNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="accountReceivableStatus"
                  value={searchCriteria.accountReceivableStatus}
                >
                  <option value={""}></option>
                  <option value={"O"}>Open</option>
                  <option value={"F"}>Finished</option>
                  <option value={"R"}>Reversed</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Created Date</FormLabel>
              </Col>
              <Col sm={7}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="createdDate"
                  name="createdDate"
                  onChange={this.onChange}
                  value={searchCriteria.createdDate}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerCode"
                  name="customerCode"
                  onChange={this.customerCodeOnChange}
                  value={searchCriteria.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Check#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="checkNumber"
                  name="checkNumber"
                  onChange={this.onChange}
                  value={searchCriteria.checkNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Card#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="cardNumber"
                  name="cardNumber"
                  onChange={this.onChange}
                  value={searchCriteria.cardNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Wire Ref#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="wireTransferNumber"
                  name="wireTransferNumber"
                  onChange={this.onChange}
                  value={searchCriteria.wireTransferNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Ach Ref#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="achNumber"
                  name="achNumber"
                  onChange={this.onChange}
                  value={searchCriteria.achNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>TendorAmount#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="totalReceivedAmount"
                  name="totalReceivedAmount"
                  className="text-end"
                  onChange={this.onChange}
                  value={searchCriteria.totalReceivedAmount}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
